/**
 * Custom Hook: useDefaultOrganizationName
 *
 * Returns the organization name for public/unauthenticated pages
 *
 * This hook is specifically for public pages (Login, ForgotPassword, ResetPassword, etc.)
 * that don't have authenticated user context. For authenticated pages that need real
 * organization data, use a different approach (fetch from API or context).
 *
 * Usage:
 *   const organizationName = useDefaultOrganizationName();
 *
 * Benefits:
 * - Single import instead of importing both React hook and constant
 * - Centralized logic if organization name needs to be fetched dynamically in the future
 * - Easy to maintain - change logic in one place, applies everywhere
 * - Follows React custom hook conventions
 * - Clear naming indicates it's for public/guest pages only
 */

import { DEFAULT_ORGANIZATION_NAME } from '../config/appConstants';

export const useDefaultOrganizationName = () => {
  return DEFAULT_ORGANIZATION_NAME;
};

export default useDefaultOrganizationName;
